export default "__VITE_ASSET__BzN$VnKP__"